<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Kartensammlung bearbeiten">
      <map-collection-form
        :loading="loading"
        :map-collection="mapCollection"
        :form-submitted="saveMapCollection"
        mode="edit"
      ></map-collection-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import MapCollectionsRepository from "@/repositories/map_collections_repository.js"
import MapCollectionForm from "@/components/forms/MapCollectionForm"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "Kartensammlung bearbeiten"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    MapCollectionForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      loading: true,
      mapCollection: {}
    }
  },
  async created() {
    try {
      this.mapCollection = await MapCollectionsRepository.get(
        this.$route.params.id
      )
      this.loading = false
    } catch (error) {
      this.loading = false
      this.handleApiError(error)
    }
  },
  methods: {
    async saveMapCollection(mapCollection) {
      await MapCollectionsRepository.update(mapCollection.id, mapCollection)
      this.$router.push({ name: "MapCollectionsPage" })
    }
  }
}
</script>
